var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.data
    ? _c("Bar", {
        ref: "chartRef",
        attrs: {
          "chart-options": _vm.chartOptions,
          "chart-data": _vm.data,
          "chart-id": _vm.chartId,
          "dataset-id-key": _vm.datasetIdKey,
          "css-classes": _vm.cssClasses,
          styles: _vm.myStyles,
          width: _vm.width,
          height: _vm.height,
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }